import { captureLanding } from "@/features/auth";

// Первый заход на сайт — до роутера и до входа: откуда пришёл посетитель (фича `auth`
// отправит это после первого входа).
export const rememberLanding = (): void => {
  captureLanding();
};
